import { IUserProfilePicture } from 'app/projects/user/src/lib/interfaces/user-profile-picture.interface';
import { IListingBookableUserBreadcrumbQuery } from '../interfaces/listing-bookable-user-breadcrumb.query.interface';
import { IListingBookableUserQuery } from '../interfaces/listing-bookable-user.query.interface';

export class ListingBookableUser {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    profilePicture: IUserProfilePicture | null;
    breadcrumbs: IListingBookableUserBreadcrumbQuery[] | undefined;
    disabledReason: string | null;
    isSelectable: boolean;

    constructor(query: IListingBookableUserQuery) {
        this.id = query.id;
        this.email = query.email;
        this.firstName = query.first_name;
        this.lastName = query.last_name;
        this.profilePicture = query.profile_picture;
        this.breadcrumbs = query.breadcrumbs;
        this.disabledReason = query.disabled_reason;
        this.isSelectable = query.is_selectable;
    }
}
